export const tours = [
  {
    id: 11,
    name: 'Ski Day at El Colorado',
    destination: 'Santiago',
    duration: '1 day',
    difficulty: 'Easy',
    price: 215,
    rating: 4.8,
    reviews: 56,
    category: 'Ski',
    icon: 'ri-snowy-line',
    image: 'https://public.readdy.ai/ai/img_res/794df6228752c6ca57c628db2b2597ae.jpg',
    includes: [
      'Round-trip transfer from hotels in Santiago to El Colorado',
      'Beginner Ski Pass',
      'Equipment rental (Boots, Skis & Poles or Snowboard)',
      'Group Ski Lessons',
      'Transport Insurance',
    ],
    notIncludes: [
      'Lunch',
      'Personal travel insurance',
      'Tips',
      'Extras not described in the itinerary',
    ],
    isBanner: true,
  },
  {
    id: 10,
    name: 'Torres del Paine – Hotel Lago Grey (Winter)',
    destination: 'Torres del Paine',
    duration: '4 days / 3 nights',
    difficulty: 'Easy',
    price: 1200,
    rating: 4.9,
    reviews: 38,
    category: 'Adventure',
    icon: 'ri-hotel-line',
    image: 'https://readdy.ai/api/search-image?query=stunning%20winter%20landscape%20of%20Torres%20del%20Paine%20national%20park%20Chile%20with%20Hotel%20Lago%20Grey%20surrounded%20by%20snow%20covered%20mountains%20dramatic%20granite%20towers%20reflected%20in%20icy%20grey%20lake%20misty%20atmosphere%20cold%20serene%20Patagonian%20winter%20scenery&width=600&height=400&seq=tour-lago-grey-winter-paine&orientation=landscape',
    includes: [
      'Private transfers from Punta Arenas or Puerto Natales',
      '3 nights accommodation in standard room at Hotel Lago Grey',
      'National park entrance fees',
      'Buffet breakfast, lunch / box lunch & dinner at Hotel Lago Grey',
      'Open bar (house wine, beers & standard cocktails)',
      'Open bar on Glacier Navigation (beers & standard cocktails)',
      'Guided excursions with English/Spanish speaking guide',
      'Wi-Fi in common areas',
      'Private transfer from Hotel Lago Grey to Punta Arenas or Puerto Natales',
    ],
  },
  {
    id: 9,
    name: 'Easter Island – 6 Days / 5 Nights',
    destination: 'Easter Island',
    duration: '6 days / 5 nights',
    difficulty: 'Easy',
    price: 1200,
    rating: 4.9,
    reviews: 41,
    category: 'Culture',
    icon: 'ri-ancient-gate-line',
    image: 'https://readdy.ai/api/search-image?query=breathtaking%20panoramic%20view%20of%20Easter%20Island%20Rapa%20Nui%20with%20iconic%20moai%20statues%20at%20Ahu%20Tongariki%20standing%20against%20vivid%20golden%20sunset%20sky%20turquoise%20Pacific%20ocean%20in%20background%20lush%20green%20hills%20ancient%20Polynesian%20civilization%20dramatic%20landscape&width=600&height=400&seq=tour-easter-island-package-1200&orientation=landscape',
    includes: [
      'Airport / Hotel transfer in regular service',
      '5 Nights at Hotel Taha Tai with breakfast included',
      'Full Day Anakaena',
      'Half Day Orongo',
      'Half Day',
      'Hotel / Airport transfer in regular service',
    ],
  },
  {
    id: 8,
    name: 'San Pedro de Atacama – Hotel Desertica',
    destination: 'San Pedro de Atacama',
    duration: '4 days / 3 nights',
    difficulty: 'Easy',
    price: 900,
    rating: 4.9,
    reviews: 62,
    category: 'Nature',
    icon: 'ri-sun-line',
    image: 'https://readdy.ai/api/search-image?query=breathtaking%20panoramic%20view%20of%20San%20Pedro%20de%20Atacama%20desert%20Chile%20with%20colorful%20rainbow%20valley%20arcoriris%20and%20ancient%20rock%20formations%20warm%20orange%20and%20red%20tones%20dramatic%20arid%20landscape%20with%20volcanic%20peaks%20in%20the%20distance%20clear%20blue%20sky&width=600&height=400&seq=tour-atacama-desertica-900&orientation=landscape',
    includes: [
      'Shared shuttle transfer airport / hotel',
      '3 Nights at Hotel Desertica with breakfast included',
      'Laguna Cejar, Ojos del Salar & Laguna Tebenquiche (**)',
      'Rainbow Valley & Yerbas Buenas (*)',
      'Shared shuttle transfer hotel / airport',
    ],
  },
  {
    id: 7,
    name: 'San Pedro de Atacama – Hotel Casa Don Tomás',
    destination: 'San Pedro de Atacama',
    duration: '4 days / 3 nights',
    difficulty: 'Easy',
    price: 600,
    rating: 4.9,
    reviews: 87,
    category: 'Nature',
    icon: 'ri-sun-line',
    image: 'https://readdy.ai/api/search-image?query=stunning%20aerial%20view%20of%20San%20Pedro%20de%20Atacama%20desert%20landscape%20Chile%20with%20salt%20flats%20lagoons%20and%20volcanic%20mountains%20in%20background%20warm%20golden%20sunset%20light%20dramatic%20arid%20scenery%20turquoise%20lagoons%20and%20white%20salt%20crust&width=600&height=400&seq=tour-atacama-package-4d&orientation=landscape',
    includes: [
      'Shared shuttle transfer airport / hotel',
      '3 Nights at Hotel Casa Don Tomás with breakfast included',
      'Laguna Cejar, Ojos del Salar & Laguna Tebenquiche (**)',
      'Valle de la Luna & Mirador de Kari',
      'Shared shuttle transfer hotel / airport',
    ],
  },
  {
    id: 1,
    name: 'Torres del Paine – Full Experience',
    destination: 'Torres del Paine',
    duration: '4 days / 3 nights',
    difficulty: 'Easy',
    price: 1800,
    rating: 4.9,
    reviews: 124,
    category: 'Adventure',
    icon: 'ri-map-pin-line',
    image: 'https://readdy.ai/api/search-image?query=group%20of%20hikers%20trekking%20through%20Torres%20del%20Paine%20national%20park%20with%20dramatic%20granite%20towers%20in%20background%20lush%20green%20valleys%20and%20turquoise%20lakes%20under%20bright%20blue%20sky%20adventure%20travel%20photography%20vibrant%20colors&width=600&height=400&seq=tour-trekking-paine&orientation=landscape',
    includes: [
      'Private transfers from Punta Arenas or Puerto Natales',
      '3 nights accommodation in standard room at Hotel Lago Grey',
      'National park entrance fees',
      'Buffet breakfast, lunch / box lunch & dinner at Hotel Lago Grey',
      'Open bar (house wine, beers & standard cocktails)',
      'Open bar on Glacier Navigation (beers & standard cocktails)',
      'Guided excursions with English/Spanish speaking guide',
      'Wi-Fi in common areas',
      'Private transfer from Hotel Lago Grey to Punta Arenas or Puerto Natales',
    ],
  },
];